import { bitsBaking } from "./bitsBaking";
import { bitsCrafts } from "./bitsCrafts";
import { bitsPatterns } from "./bitsPatterns";

export const bitsData = [
    ...bitsBaking,
    ...bitsCrafts,
    ...bitsPatterns
];
